var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.11602 0.315831L3.9173 5.40582L1.88398 3.40848C1.60518 3.1361 1.19883 3.02972 0.817987 3.12942C0.437146 3.22912 0.139675 3.51975 0.0376291 3.89184C-0.0644169 4.26393 0.0444649 4.66095 0.32326 4.93333L3.13694 7.68236C3.34332 7.88565 3.62424 8 3.9173 8C4.21036 8 4.49129 7.88565 4.69766 7.68236L10.6767 1.84068C10.9555 1.56829 11.0644 1.17128 10.9624 0.799189C10.8603 0.4271 10.5629 0.136465 10.182 0.0367644C9.80117 -0.0629366 9.39482 0.0434431 9.11602 0.315831Z"}));
}

Check.defaultProps = {"width":"11","height":"8","viewBox":"0 0 11 8"};

module.exports = Check;

Check.default = Check;
